import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpFamilyPlugin = function (_NebulaModuleBase) {
    _inherits(UpFamilyPlugin, _NebulaModuleBase);

    function UpFamilyPlugin() {
        _classCallCheck(this, UpFamilyPlugin);

        return _possibleConstructorReturn(this, (UpFamilyPlugin.__proto__ || Object.getPrototypeOf(UpFamilyPlugin)).apply(this, arguments));
    }

    _createClass(UpFamilyPlugin, [{
        key: 'addFamilyRoom',
        value: function addFamilyRoom(data) {
            return this.generatePromiseByFunction('familyAddRoomForFamily', data);
        }
    }, {
        key: 'changeFamilyAdmin',
        value: function changeFamilyAdmin(data) {
            return this.generatePromiseByFunctionWithParams('changeFamilyAdminForFamily', data);
        }
    }, {
        key: 'createFamily',
        value: function createFamily(data) {
            return this.generatePromiseByFunctionWithParams('createFamilyForFamily', data);
        }
    }, {
        key: 'createFamilyFloor',
        value: function createFamilyFloor(data) {
            return this.generatePromiseByFunctionWithParams('createFamilyFloorForFamily', data);
        }
    }, {
        key: 'deleteFamilyAsAdmin',
        value: function deleteFamilyAsAdmin(data) {
            return this.generatePromiseByFunctionWithParams('deleteFamilyAsAdminForFamily', data);
        }
    }, {
        key: 'deleteFamilyFloor',
        value: function deleteFamilyFloor(data) {
            return this.generatePromiseByFunction('deleteFamilyFloorForFamily', data);
        }
    }, {
        key: 'deleteMemberAsAdmin',
        value: function deleteMemberAsAdmin(data) {
            return this.generatePromiseByFunctionWithParams('adminDeleteMemberForFamily', data);
        }
    }, {
        key: 'exitFamilyAsAdmin',
        value: function exitFamilyAsAdmin(data) {
            return this.generatePromiseByFunctionWithParams('exitFamilyAsAdminForFamily', data);
        }
    }, {
        key: 'exitFamilyAsMember',
        value: function exitFamilyAsMember(data) {
            return this.generatePromiseByFunctionWithParams('exitFamilyAsMemberForFamily', data);
        }
    }, {
        key: 'getCurrentFamily',
        value: function getCurrentFamily() {
            return this.generatePromiseByFunctionWithParams('getCurrentFamilyForFamily', null);
        }
    }, {
        key: 'getFamilyMap',
        value: function getFamilyMap() {
            return this.generatePromiseByFunctionWithParams('getFamiliesForFamily', null);
        }
    }, {
        key: 'inviteMemberAsAdmin',
        value: function inviteMemberAsAdmin(data) {
            return this.generatePromiseByFunctionWithParams('adminInviteMemberForFamily', data);
        }
    }, {
        key: 'moveDevicesToOtherRoom',
        value: function moveDevicesToOtherRoom(data) {
            return this.generatePromiseByFunctionWithParams('moveDevicesToOtherRoomForFamily', data);
        }
    }, {
        key: 'removeFamilyRoom',
        value: function removeFamilyRoom(data) {
            return this.generatePromiseByFunction('familyRemoveRoomForFamily', data);
        }
    }, {
        key: 'setCurrentFamily',
        value: function setCurrentFamily(data) {
            return this.generatePromiseByFunctionWithParams('setCurrentFamilyForFamily', data);
        }
    }, {
        key: 'updateDeviceName',
        value: function updateDeviceName(data) {
            return this.generatePromiseByFunctionWithParams('updateDeviceNameForFamily', data);
        }
    }, {
        key: 'updateFamilyInfo',
        value: function updateFamilyInfo(data) {
            return this.generatePromiseByFunctionWithParams('updateFamilyInfoForFamily', data);
        }
    }, {
        key: 'updateRoomList',
        value: function updateRoomList(data) {
            return this.generatePromiseByFunctionWithParams('refreshRoomListForFamily', data);
        }
    }, {
        key: 'updateRoomName',
        value: function updateRoomName(data) {
            return this.generatePromiseByFunction('updateRoomNameForFamily', data);
        }
    }, {
        key: 'queryFirstMember',
        value: function queryFirstMember(data) {
            return this.generatePromiseByFunctionWithParams('queryFirstMemberForFamily', data);
        }
    }, {
        key: 'queryFamilyInfo',
        value: function queryFamilyInfo(data) {
            return this.generatePromiseByFunctionWithParams('queryFamilyInfoForFamily', data);
        }
    }, {
        key: 'queryFamilyInfoFromCache',
        value: function queryFamilyInfoFromCache(data) {
            return this.generatePromiseByFunctionWithParams('queryFamilyInfoFromCacheForFamily', data);
        }
    }, {
        key: 'addVirtualMember',
        value: function addVirtualMember(data) {
            return this.generatePromiseByFunctionWithParams('addVirtualMemberForFamily', data);
        }
    }, {
        key: 'modifyVirtualMember',
        value: function modifyVirtualMember(data) {
            return this.generatePromiseByFunctionWithParams('modifyVirtualMemberForFamily', data);
        }
    }, {
        key: 'moveDevicesToFamily',
        value: function moveDevicesToFamily(data) {
            return this.generatePromiseByFunctionWithParams('moveDevicesToFamilyForFamily', data);
        }
    }, {
        key: 'unbindDeviceFromFamily',
        value: function unbindDeviceFromFamily(data) {
            return this.generatePromiseByFunctionWithParams('unbindDeviceFromFamilyForFamily', data);
        }
    }, {
        key: 'removeDevicesFromFamily',
        value: function removeDevicesFromFamily(data) {
            return this.generatePromiseByFunctionWithParams('removeDevicesFromFamilyForFamily', data);
        }
    }, {
        key: 'saveRoomsOrder',
        value: function saveRoomsOrder(data) {
            return this.generatePromiseByFunction('saveRoomsOrderForFamily', data);
        }
    }, {
        key: 'modifyMemberRole',
        value: function modifyMemberRole(data) {
            return this.generatePromiseByFunctionWithParams('modifyMemberRoleForFamily', data);
        }
    }, {
        key: 'modifyVirtualMemberRole',
        value: function modifyVirtualMemberRole(data) {
            return this.generatePromiseByFunctionWithParams('modifyVirtualMemberRoleForFamily', data);
        }
    }]);

    return UpFamilyPlugin;
}(NebulaModuleBase);